import React from 'react';
import {HeaderPortal} from '@rocket-ui/components';
import cn from 'classnames';
import type {OrderActionDescriptor} from 'features/order-actions';
import {Button} from 'ui/Button';

import styles from './DraftTaskActions.module.css';

export interface DraftTaskActionsProps {
	actions: OrderActionDescriptor[];
}

const primaryButtonClassName = cn(styles.acceptButton, 'px-8 py-2 max-sm:!w-full');
const secondaryButtonClassName = cn(styles.rejectButton, '!h-auto px-8 py-2 max-sm:!w-full sm:!w-auto');

function OrderActionButtons({actions, className}: {actions: OrderActionDescriptor[]; className: string}): React.ReactElement {
	return (
		<footer className={className} aria-label="Действия по заказу">
			{actions.map((action) => {
				const buttonClassName = action.variant === 'primary' ? primaryButtonClassName : secondaryButtonClassName;

				return (
					<Button
						key={action.id}
						type="button"
						className={buttonClassName}
						onClick={action.onSelect}
						disabled={action.disabled}
						{...(action.variant === 'secondary' ? {theme: 'white'} : {})}
					>
						{action.label}
					</Button>
				);
			})}
		</footer>
	);
}

export function DraftTaskActions({actions}: DraftTaskActionsProps): React.ReactElement | null {
	if (!actions.length) return null;

	return (
		<>
			<HeaderPortal position="right">
				<OrderActionButtons actions={actions} className={cn(styles.actionsFooter, styles.actionsHeader)} />
			</HeaderPortal>
			<OrderActionButtons actions={actions} className={cn(styles.actionsFooter, styles.actionsMobileFooter)} />
		</>
	);
}
